// ============================================
// LIGA AJUPAM - Evento "cambió la info de tu liga" (v6.11.43)
// ============================================
// Canal único para avisarle a la UI que un refresco en segundo plano detectó un
// cambio ESTRUCTURAL en los datos del participante (zona asignada, categoría,
// edición, temporada que arranca). Lo consume `LeagueDataUpdateBanner`.
//
// Mismo patrón que 'app-update-available' (código nuevo del service worker), pero
// para DATOS. Nació del reporte al arrancar la 5ta edición del Gran Mendoza: con
// la app ya abierta, el participante tenía que recargar a mano para que
// reconociera de qué zona era su equipo.

export const LEAGUE_DATA_UPDATED_EVENT = 'league-data-updated';

export interface LeagueDataUpdatedDetail {
  /** Titular corto y concreto. Ej: "Tu equipo quedó en la Zona A". */
  message: string;
  /** Qué disparó el aviso — útil para no repetir el mismo cartel dos veces. */
  reason: 'zone' | 'category' | 'league' | 'season-start' | 'team';
}

export const emitLeagueDataUpdated = (detail: LeagueDataUpdatedDetail): void => {
  window.dispatchEvent(
    new CustomEvent<LeagueDataUpdatedDetail>(LEAGUE_DATA_UPDATED_EVENT, { detail })
  );
};
